module.exports = __webpack_public_path__ + "fonts/fontawesome-webfont.woff";


//////////////////
// WEBPACK FOOTER
// ./~/font-awesome/fonts/fontawesome-webfont.woff?v=4.7.0
// module id = 686
// module chunks = 0